import { useParams, Link } from "react-router-dom";
import { PasswordGatePage } from "./PasswordGatePage.js";
import { Layout } from "../components/common/Layout.js";
import { UploadDropzone } from "../components/upload/UploadDropzone.js";
import { UploadQueue } from "../components/upload/UploadQueue.js";
import { useUploadQueue } from "../hooks/useUploadQueue.js";

interface UploadContentProps {
  token: string;
  eventName: string;
  uploadsEnabled: boolean;
  maxFileSizeBytes: number;
  maxFilesPerUpload: number;
}

function UploadContent({
  token,
  eventName,
  uploadsEnabled,
  maxFileSizeBytes,
  maxFilesPerUpload,
}: UploadContentProps) {
  const { items, addFiles, retry, remove, isUploading } = useUploadQueue(
    token,
    maxFileSizeBytes,
    maxFilesPerUpload,
  );

  return (
    <Layout
      title={eventName}
      actions={
        <Link to={`/m/${token}`} className="btn btn-secondary">
          Voir la galerie
        </Link>
      }
    >
      <div className="stack">
        {uploadsEnabled ? (
          <UploadDropzone
            onFiles={addFiles}
            maxFileSizeBytes={maxFileSizeBytes}
            maxFilesPerUpload={maxFilesPerUpload}
          />
        ) : (
          <div className="card">
            <p>Les envois sont désactivés pour le moment pour cet événement.</p>
          </div>
        )}
        <UploadQueue items={items} isUploading={isUploading} onRetry={retry} onRemove={remove} />
      </div>
    </Layout>
  );
}

export function UploadPage() {
  const { token } = useParams<{ token: string }>();
  if (!token) return null;

  return (
    <PasswordGatePage token={token}>
      {(event) => (
        <UploadContent
          token={token}
          eventName={event.name}
          uploadsEnabled={event.uploadsEnabled}
          maxFileSizeBytes={event.maxFileSizeBytes}
          maxFilesPerUpload={event.maxFilesPerUpload}
        />
      )}
    </PasswordGatePage>
  );
}
